import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PeriodicReportService } from '../_services/periodic-report.service';

@Component({
  selector: 'app-periodic-report',
  templateUrl: './periodic-report.component.html',
  styleUrls: ['./periodic-report.component.scss'],
  providers: [DatePipe],
})
export class PeriodicReportComponent implements OnInit, OnDestroy {
  loading: boolean = true;
  data: any;
  subscriptions: Subscription[] = [];
  form: FormGroup;
  totalScore = [];
  firstDateOfMonth: any;
  lastDateOfMonth: any;
  showOperations = false;
  showAvgOperations = false;
  showTotalOperations = false;
  operationsData: any;
  totalOperationsData: any;

  constructor(
    private periodRepostService: PeriodicReportService,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  /* ====================================
    *              LIFECYCLES
    ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      date_from: ['', Validators.required],
      date_to: ['', Validators.required],
      coef: '',
    });

    this.getStartAndEndOfMonth();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
  /* ====================================
    *             MAIN FEATURES
    ======================================= */
  getData(dateFrom, dateTo, coef = '') {
    this.totalScore = [];

    this.loading = true;
    this.subscriptions.push(
      this.periodRepostService
        .getAll(dateFrom, dateTo, coef)
        .subscribe((responseData) => {
          this.data = responseData;
          this.loading = false;

          this.data.total_score.header = 'Ukupni učinak sumarno';
          this.data.total_score.headerAvg = 'Ukupni učinak prosečno';

          this.totalScore.push(this.data.total_score);
        })
    );
  }

  onSearch() {
    const form = this.form.getRawValue();

    const dateFrom = this.datePipe.transform(form.date_from, 'dd.MM.yyyy');
    const dateTo = this.datePipe.transform(form.date_to, 'dd.MM.yyyy');

    if (!form.date_from || !form.date_to) {
      this.getData(this.firstDateOfMonth, this.lastDateOfMonth, form.coef);
    } else {
      this.getData(dateFrom, dateTo, form.coef);
    }
  }

  onExportCsv() {
    const form = this.form.getRawValue();

    form.date_from = this.datePipe.transform(form.date_from, 'dd.MM.yyyy');
    form.date_to = this.datePipe.transform(form.date_to, 'dd.MM.yyyy');

    this.subscriptions.push(
      this.periodRepostService
        .exportToCSV(form.date_from, form.date_to, form.coef)
        .subscribe((pdfHref) => {
          window.open(pdfHref.data, '_blank');
        })
    );
  }

  /* ====================================
   *             HELPERS
   ======================================= */
  clearFilters(controlName) {
    this.form.get(controlName).setValue('');
    this.getStartAndEndOfMonth();
    // kako treba da radi ako se unese samo krajnji ili poceni datum ?
  }

  getStartAndEndOfMonth() {
    const currentDate = new Date();

    // Get the first date of the month
    const firstDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );

    // Get the last date of the month
    const lastDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );

    // Format the dates as desired
    const firstDay = ('0' + firstDate.getDate()).slice(-2);
    const firstMonth = ('0' + (firstDate.getMonth() + 1)).slice(-2); // Adding 1 because months are zero-based
    const firstYear = firstDate.getFullYear();
    this.firstDateOfMonth = firstDay + '.' + firstMonth + '.' + firstYear;

    const lastDay = ('0' + lastDate.getDate()).slice(-2);
    const lastMonth = ('0' + (lastDate.getMonth() + 1)).slice(-2); // Adding 1 because months are zero-based
    const lastYear = lastDate.getFullYear();
    this.lastDateOfMonth = lastDay + '.' + lastMonth + '.' + lastYear;

    this.getData(this.firstDateOfMonth, this.lastDateOfMonth);
  }

  onShowOperations(operations) {
    this.showOperations = true;
    this.operationsData = operations;
  }

  onShowTotalOperations(operations) {
    this.showTotalOperations = true;
    this.totalOperationsData = operations;
  }

  onShowAvgOperations(operations) {
    this.showAvgOperations = true;
    this.totalOperationsData = operations;
  }
  onCloseModal(showModal: boolean) {}
}
